import { Card, CardContent, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const SelectSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-between gap-3 border-b', className);

	// Render
	return (
		<Card size='sm' className={rootClassName}>
			<span className='flex-start-top gap-3 w-full'>
				<CardHeader className='aspect-[1/1] rounded-control w-10'>
					<Skeleton className='leading-[inherit]' />
				</CardHeader>
				<CardContent className='w-2/3'>
					<CardTitle>
						<Skeleton />
					</CardTitle>
				</CardContent>
			</span>
			<span className='aspect-[1/1] w-8'>
				<Skeleton />
			</span>
		</Card>
	);
};
export { SelectSkeleton };
// Docs:
// https://github.com/dvtng/react-loading-s#readme
